/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Raffle_Wrong_StateInputs */



/**
* | output |
* | --- |
* | "Raffle requires tournament in Waiting, Playing, or Finished state" |
*
* @param {Err_Tournament_Raffle_Wrong_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_raffle_wrong_state = /** @type {((inputs?: Err_Tournament_Raffle_Wrong_StateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Raffle_Wrong_StateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le tirage nécessite un tournoi en état En attente, En cours ou Terminé")
	if (locale === "es") return /** @type {LocalizedString} */ ("El sorteo requiere un torneo en estado En espera, En juego o Finalizado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O sorteio requer o torneio no estado Aguardando, Em jogo ou Finalizado")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'estrazione richiede il torneo in stato In Attesa, In gioco o Terminato")
	return /** @type {LocalizedString} */ ("Raffle requires tournament in Waiting, Playing, or Finished state")
});